export const MODEL_CLASSIFICATIONS = 'MODEL_CLASSIFICATIONS';
export const MODEL_CLASSIFICATIONS_SUCCESS = 'MODEL_CLASSIFICATIONS_SUCCESS';
export const MODEL_CLASSIFICATIONS_ERROR = 'MODEL_CLASSIFICATIONS_ERROR';


export const DELETE_MODEL_CLASSIFICATION = 'DELETE_MODEL_CLASSIFICATION';
export const DELETE_MODEL_CLASSIFICATION_SUCCESS = 'DELETE_MODEL_CLASSIFICATION_SUCCESS';
export const DELETE_MODEL_CLASSIFICATION_ERROR = 'DELETE_MODEL_CLASSIFICATION_ERROR';



export const EDIT_MODEL_CLASSIFICATION = 'EDIT_MODEL_CLASSIFICATION';
export const EDIT_MODEL_CLASSIFICATION_SUCCESS = 'EDIT_MODEL_CLASSIFICATION_SUCCESS';
export const EDIT_MODEL_CLASSIFICATION_ERROR = 'EDIT_MODEL_CLASSIFICATION_ERROR';


export const ADD_MODEL_CLASSIFICATION = 'ADD_MODEL_CLASSIFICATION';
export const ADD_MODEL_CLASSIFICATION_SUCCESS = 'ADD_MODEL_CLASSIFICATION_SUCCESS';
export const ADD_MODEL_CLASSIFICATION_ERROR = 'ADD_MODEL_CLASSIFICATION_ERROR';

export const ASSET_TYPE_DETAILS = 'ASSET_TYPE_DETAILS';
export const ASSET_TYPE_DETAILS_SUCCESS = 'ASSET_TYPE_DETAILS_SUCCESS';
export const ASSET_TYPE_DETAILS_ERROR = 'ASSET_TYPE_DETAILS_ERROR';

export const MODEL_CLASSIFICATION_DETAILS = 'MODEL_CLASSIFICATION_DETAILS';
export const MODEL_CLASSIFICATION_DETAILS_SUCCESS = 'MODEL_CLASSIFICATION_DETAILS_SUCCESS';
export const MODEL_CLASSIFICATION_DETAILS_ERROR = 'MODEL_CLASSIFICATION_DETAILS_ERROR';

export const PREDICTION_LEVEL_LIST = 'PREDICTION_LEVEL_LIST';
export const PREDICTION_LEVEL_LIST_SUCCESS = 'PREDICTION_LEVEL_LIST_SUCCESS';
export const PREDICTION_LEVEL_LIST_ERROR = 'PREDICTION_LEVEL_LIST_ERROR';